import api from './axios';

const BASE = '/orders';

export const getOrders = (page = 0, size = 10, filters = {}) =>
  api.get(BASE, {
    params: { page, size, sort: ['createdAt,desc', 'id,desc'], ...filters },
    paramsSerializer: { indexes: null },
  });

export const createOrder = (data) => api.post(BASE, data);

export const updateOrder = (id, data) => api.put(`${BASE}/${id}`, data);

export const deleteOrder = (id) => api.delete(`${BASE}/${id}`);

export const updateOrderStatus = (id, status) =>
  api.patch(`${BASE}/${id}/status`, { status });

export const updateOrderPayment = (id, paymentStatus) =>
  api.patch(`${BASE}/${id}/payment`, { paymentStatus });

export const banOrderFingerprint = (id, data) =>
  api.post(`${BASE}/${id}/ban-fingerprint`, data);
